// HashtagCategoryItem.js
'use strict';
import { connect } from 'react-redux';
import setRecentSearchHashtag from '../action/setRecentSearchHashtag.js';

import HashtagCategoryItem from '../component/HashtagCategoryItem.jsx';
import getHashtagData from '../selector/getHashtagData.js';

const mapStateToProps = (state, { hashtag }) => {
  return {
    type: getHashtagData(state, hashtag, 'latestMessageType'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setRecentSearchHashtag: ({ query }) =>
      dispatch(setRecentSearchHashtag({ query })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HashtagCategoryItem);
